import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

const PdfCarousel = ({ url, title }) => {
  // Usa la URL real del PDF
  return (
    <Box sx={{ textAlign: 'center', my: 3 }}>
      {title && <Typography variant="h6" sx={{ mb: 2 }}>{title}</Typography>}
      <iframe
        src={url}
        style={{ width: '100%', height: '600px', border: 'none' }}
        title={title || 'PDF'}
        allowFullScreen
      />
    </Box>
  );
};

PdfCarousel.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default PdfCarousel;
